declare global {
  interface Window {
    pendo: any;
  }
}

export abstract class PendoServiceModel {
  /** Pendo API object */
  private _pendo: any;

  get pendo() {
    return this._pendo;
  }
  /** implement function that calls pendo.initialize with any argument needed */
  abstract initUser(...args: any[]): void;

  constructor() {
    const pendo = window.pendo || [];
    pendo.load = function (apiKey) {
      (function (p, e, n, d, o) {
        var v, w, x, y, z;
        o = p[d] = p[d] || {};
        o._q = o._q || [];
        v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];
        for (w = 0, x = v.length; w < x; ++w)
          (function (m) {
            o[m] =
              o[m] ||
              function () {
                o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
              };
          })(v[w]);
        y = e.createElement(n);
        y.async = !0;
        y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
        z = e.getElementsByTagName(n)[0];
        z.parentNode.insertBefore(y, z);
      })(window, document, 'script', 'pendo');
    };
    window.pendo = this._pendo = pendo;
  }

  load(apiKey: string) {
    if (this._pendo) {
      this._pendo.load(apiKey);
    } else {
      throw new Error('Pendo is not initialized');
    }
  }

  /**  This function creates visitors and accounts in Pendo */
  initialize(visitor: any, account: any) {
    this._pendo.initialize({
      visitor,
      account,
    });
  }

  trackEvent(eventName: string, data: any): void {
    this.pendo.track ? this.pendo.track(eventName, data) : null;
  }
}
